<template>
  <section class="bonus-detail">
    <!-- ページタイトル -->
    <div class="page-title d-flex align-items-center">
      <div class="icon-area">
        <img src="@/assets/img/details_sub.jpg" alt="ボーナス明細" />
      </div>
      <h1 class="mb-0">ボーナス明細</h1>
    </div>

    <!-- タブ切り替え -->
    <div class="tab-area d-flex">
      <div 
        class="tab-item"
        @click="$emit('change-tab', 'monthly')"
      >
        月次
      </div>
      <div class="tab-item active">年次</div>
      
      <a :href="downloadUrl" target="_blank" class="tab-print" v-if="isFiscalYearActive">
        <i class="fa fa-print"></i> ダウンロード
      </a>
    </div>

    <!-- 明細コンテンツ部分 -->
    <div class="detail-content">
      <!-- 年選択エリア -->
      <div class="date-selection py-2">
        <div class="d-flex justify-content-between align-items-center sp_column">
          <label>対象年</label>
          <div class="date-selector">
            <select v-model="localSelectedYear" @change="handleYearChange">
              <option v-for="year in yearOptions" :key="year" :value="year">
                {{ year }}年
              </option>
            </select>
            <i class="fa fa-calendar"></i>
          </div>
        </div>
      </div>

      <!-- 年間一覧 -->
      <div class="year-summary bg-light p-3" v-if="yearlyData.isGetYearlyData">
        <h3 class="summary-title">年間一覧</h3>
        <div class="summary-totals d-flex justify-content-between border-bottom py-2">
          <div class="total-item d-flex align-items-center">
            <span class="total-label text-accent">支払総額</span>
            <div class="amount-area text-accent ml-2">
              <span class="amount">{{ yearlyData.totalPayment }}</span>
              <span>円</span>
            </div>
          </div>
          <div class="total-item d-flex align-items-center">
            <span class="total-label">源泉徴収総額</span>
            <div class="amount-area ml-2">
              <span class="amount">{{ yearlyData.totalWithholding }}</span>
              <span>円</span>
            </div>
          </div>
        </div>

        <!-- 年間明細テーブル -->
        <table class="year-detail-table mt-3" v-if="yearlyData.isGetYearlyData">
          <thead>
            <tr>
              <th>対象月</th>
              <th>支払金額</th>
              <th>源泉徴収税額</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in yearlyData.months" :key="index">
              <td>{{ item.month }}月</td>
              <td class="text-right">{{ formatCurrency(item.amount) }}円</td>
              <td class="text-right">{{ formatCurrency(item.tax) }}円</td>
            </tr>
          </tbody>
        </table>
      </div>
      
      <!-- 会社情報 -->
      <div class="company-info text-right mt-5">
        <p class="mb-0">株式会社マナビス化粧品</p>
        <p class="mb-0">登録番号：T3040001030675</p>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'BonusYearDetail',
  props: {
    yearlyData: {
      type: Object,
      required: true
    },
    selectedYear: {
      type: String,
      required: true
    }
  },
  watch: {
    // 親からselectedYearが変更された場合に反映する
    selectedYear(newValue) {
      console.log("親から年が変更されました:", newValue);
      this.localSelectedYear = newValue;
    },
    // yearlyDataが変更された場合に選択年を確認・更新
    yearlyData: {
      handler(newValue) {
        if (newValue && newValue.selectedYear) {
          console.log("年次データが更新され、選択年を確認します:", newValue.selectedYear);
          // 値更新
          this.updateDownloadUrl();
          // yearlyDataの選択年が現在の選択年と異なる場合は更新
          if (this.localSelectedYear !== newValue.selectedYear) {
            console.log("年次データの選択年が異なるため更新します:", newValue.selectedYear);
            this.localSelectedYear = newValue.selectedYear;
          }
        }
      },
      deep: true // オブジェクト内部のプロパティ変更も検知
    }
  },
  mounted() {
    console.log("BonusYearDetail mounted");
    // 年の選択肢を作成
    this.generateYearOptions();
    console.log("年の選択肢:", this.yearOptions);
    this.updateDownloadUrl();
  },
  data() {
    // 現在の年を取得
    const currentYear = new Date().getFullYear();
    const memberId = this.yearlyData && this.yearlyData.member ? this.yearlyData.member : "118188";
    
    return {
      localSelectedYear: this.selectedYear, // 親から渡された年を内部状態として保持
      yearOptions: [], // 年の選択肢（マウント時に生成）
      currentYear, // 現在の年を保持
      memberId,
      isFiscalYearActive: false,
      downloadUrl: ""  // PDFダウンロード用のURL
    };
  },
  methods: {
    generateYearOptions() {
      // 現在の年を含めた過去5年分の年を生成
      this.yearOptions = [];
      for (let i = 0; i < 5; i++) {
        this.yearOptions.push((this.currentYear - i).toString());
      }
    },
    handleYearChange() {
      // 年が変更されたときの処理
      console.log("選択された年:", this.localSelectedYear);
      // 親コンポーネントに年の変更を通知
      this.$emit('year-changed', this.localSelectedYear);
      // 値更新
      this.updateDownloadUrl();
    },
    printDetail() {
      window.print();
    },
    formatCurrency(value) {
      if (!value) return '0';
      // 既にカンマ区切りになっている場合はそのまま返す
      if (typeof value === 'string' && value.includes(',')) {
        return value;
      }
      // 数値に変換してカンマ区切りにする
      return parseInt(value).toLocaleString();
    },
    updateDownloadUrl() {

      // 現在日付が 2/1～12/31 であれば前年度を表示
      var now = new Date();
      var dtF = new Date(now.getFullYear(), 2 - 1, 1, 0, 0, 0);
      var dtT = new Date(now.getFullYear(), 12 - 1, 31, 0, 0, 0);

      if (Number(this.localSelectedYear) == Number(now.getFullYear() - 1) &&
          now >= dtF && now <= dtT) {
          this.isFiscalYearActive = true;
      } else {
          this.isFiscalYearActive = false;
      }
      
      // このURLはmounted時と年月変更時に更新される
      // detailDataとmemberプロパティが存在するかチェック
      const targetMonth = this.localSelectedYear;
      this.downloadUrl = `/Core/Common/NotificationWeb/PostForWeb?Member=${this.memberId}&TargetMonth=${targetMonth}&out=9`;
    }
  }
};
</script>

<style scoped>
.bonus-detail {
  max-width: 800px;
  margin: 0 auto;
  font-family: 'Hiragino Sans', 'Meiryo', sans-serif;
  color: #333;
  background-color: #fff;
  padding: 20px 30px;
  box-shadow: 0 0 10px rgba(0,0,0,0.1);
}

.header-logo img {
  height: 40px;
}

.text-center {
  text-align: center;
}

.my-3 {
  margin-top: 15px;
  margin-bottom: 15px;
}

.page-title {
  border-radius: 0;
  padding: 10px 15px;
  margin: 20px 0;
}

.page-title h1 {
  font-size: 1.2em;
  font-weight: normal;
}

.icon-area img {
  width: 75px;
  margin-right: 15px;
}

.d-flex {
  display: flex;
}

.align-items-center {
  align-items: center;
}

.tab-area {
  margin-bottom: 20px;
  position: relative;
}

.tab-item {
  padding: 10px 20px;
  cursor: pointer;
  background-color: #ccc;
  color: #666;
  text-align: center;
  border-radius: 5px 5px 0 0;
  margin-right: 3px;
  flex: 1;
  max-width: 100px;
}

.tab-item.active {
  background-color: #e74c3c;
  color: white;
}

.tab-print {
  padding: 10px 20px;
  position: absolute;
  right: 0;
  background-color: #666;
  color: white;
  border-radius: 5px 5px 0 0;
  cursor: pointer;
}

.detail-content {
  padding: 10px;
}

/* .date-selection select {
  padding: 5px 15px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 1rem;
} */

.bg-light {
  background-color: #f9f9f9;
}

.p-3 {
  padding: 15px;
}

.summary-title {
  margin-bottom: 15px;
  font-weight: 600;
}

.text-accent {
  color: #e74c3c;
}

.ml-2 {
  margin-left: 10px;
}

.amount {
  font-weight: 600;
  margin-right: 5px;
}

.year-detail-table {
  width: 100%;
  border-collapse: collapse;
}

.year-detail-table th, .year-detail-table td {
  padding: 8px 15px;
  border-bottom: 1px solid #ddd;
}

.year-detail-table th {
  background-color: #f0f0f0;
  text-align: center;
}

.text-right {
  text-align: right;
}

.mt-3 {
  margin-top: 15px;
}

.mt-5 {
  margin-top: 30px;
}

.company-info {
  font-size: 0.95em;
}

.mb-0 {
  margin-bottom: 0;
}
/* 共通デザインに調整 */
.btn {
    border: 1px solid #000 !important;
    padding: 10px 20px;
    color: #000 !important;
    font-weight: 300 !important;
    background-color: #fff;
    cursor: pointer;
}
button {
  font-family: Noto Sans JP, ヒラギノ角ゴ Pro, Hiragino Kaku Gothic Pro, メイリオ, Meiryo, sans-serif;
  line-height: 1.8 !important;
  color: #424242 !important;
  font-weight: 300 !important;
  font-size: 1.8rem;
}
select {
  width: 120px;
  height: 36px; 
  font-size: 1.2em;
  border: 1px solid #aaa;
  border-radius: 5px;
  box-sizing: border-box;
}

/* スマートフォンレイアウト */
@media screen and (min-width: 1px) and (max-width: 991px) {
  .sp_column {
    flex-direction: column;
    align-items: center;
  }
  .bonus-detail {
    padding: 20px 0px;
  }
}
</style> 